import Header from "@/components/site/Header";
import Hero from "@/components/site/Hero";
import TrustBadges from "@/components/site/TrustBadges";
import Services from "@/components/site/Services";
import WorkGallery from "@/components/site/WorkGallery";
import HowItWorks from "@/components/site/HowItWorks";
import WhyUs from "@/components/site/WhyUs";
import RVCleaning from "@/components/site/RVCleaning";
import OwnerNote from "@/components/site/OwnerNote";
import Testimonials from "@/components/site/Testimonials";
import FAQ from "@/components/site/FAQ";
import Footer from "@/components/site/Footer";
import StickyCall from "@/components/site/StickyCall";

export default function Landing() {
  return (
    <div className="bg-white text-teal" data-testid="landing-page">
      <Header />
      <main>
        <Hero />
        <TrustBadges />
        <Services />
        <WorkGallery />
        <HowItWorks />
        <WhyUs />
        <RVCleaning />
        <OwnerNote />
        <Testimonials />
        <FAQ />
      </main>
      <Footer />
      <StickyCall />
    </div>
  );
}
